module.exports = __webpack_public_path__ + "img/icon-tri-viewtrivia.1b8801cb.png";